import { useI18n } from "@/i18n/client";
import Link from "next/link";
import useStoreKeys from "@/hooks/useStoreKeys";
import { SearchSuggestionSkeleton } from "@/components/UI/Skeleton/SearchSkeleton";
import styles from "./SearchArticles.module.scss";
import { NewsType } from "@/lib/5874/types";

interface SearchArticlesProps {
	searchTerm: string;
	articles: NewsType[];
	manageArticleClick: () => void;
	maxLimit: number;
	isLoading: boolean;
}

const SearchArticles = ({
	searchTerm,
	articles,
	manageArticleClick,
	maxLimit = 3,
	isLoading,
}: SearchArticlesProps) => {
	const t = useI18n();
	const { store, lang } = useStoreKeys();

	return (
		<div className={styles.articles}>
			<div className={styles.header}>{t("search.news")}</div>
			<div className={styles.list}>
				{!isLoading &&
					articles?.map((article, index) => {
						// Max of 3 articles
						if (index + 1 > maxLimit) return null;

						return (
							<Link
								key={article.id}
								className={styles.item}
								href={article.data.url}
								onClick={() => manageArticleClick()}
							>
								{article.name}
							</Link>
						);
					})}
				{searchTerm && !articles.length && !isLoading && (
					<span>{t("search.noResults.noArticlesFound")}</span>
				)}
				{isLoading && <SearchSuggestionSkeleton />}
			</div>
		</div>
	);
};

export default SearchArticles;
